export default "//yastatic.net/s3/distribution/pythia/frontend/_/3500e54aa22979b605b72255ca7ecc7c.svg";